import React from "react";
import PropTypes from "prop-types";

import CenterContent from "../components/common/CenterContent";
import HomeHelmet from "../components/home/HomeHelmet";
import Link from "../components/common/Link";
import Page from "../components/common/Page";
import PrettyLink from "../components/common/PrettyLink";
import style from "./index.module.css";
import getArticlesAndGuides from "../logic/getArticlesAndGuides";

class IndexPage extends React.Component {
  renderArticle = article => {
    return (
      <li key={article.path} className={style.articleLink}>
        <PrettyLink to={article.path}>{article.title}</PrettyLink>
      </li>
    );
  };

  render() {
    // for now guides and articles are all mixed together
    const articles = getArticlesAndGuides(this.props.data, 5);

    return (
      <Page>
        <HomeHelmet />
        <CenterContent className={style.content}>
          <h1>Learn the Latest JavaScript Tools</h1>

          <h2>Build apps faster and have more fun doing it 🎉</h2>

          <h3>Where to begin?</h3>

          <ul>
            <li>
              <span>
                Searching for a tool, starter project, or library? Go to the{" "}
                <PrettyLink to="/lists/">lists</PrettyLink>.
              </span>
            </li>
            <li>
              <span>
                Looking for help with React, Webpack, CSS Modules or other
                tools? Go to the{" "}
                <PrettyLink to="/articles/">articles</PrettyLink>.
              </span>
            </li>
            <li>
              <span>
                Absolute beginner to React and trying to get started? Read about
                building a{" "}
                <PrettyLink to="/tiny-unique-app/">tiny app</PrettyLink>.
              </span>
            </li>
          </ul>

          <h3>Latest Articles</h3>
          <ul>{articles.map(this.renderArticle)}</ul>
          <div className={style.allArticlesCenter}>
            <Link className={style.allArticlesLink} to="/articles/">
              All Articles
            </Link>
          </div>
        </CenterContent>
      </Page>
    );
  }
}
IndexPage.propTypes = {
  data: PropTypes.object.isRequired
};
export default IndexPage;

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: 5
    ) {
      edges {
        node {
          frontmatter {
            archive
            title
            subtitle
            date
            path
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js